import styled from 'styled-components';

export const Wrapper = styled.div.attrs({ className: 'dsc-copyableTitle' })`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const Title = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  //color: var(--secondaryGrey);
`;

export const CopyIcon = styled.div`
  display: flex;
  transition: all 0.2s ease;

  svg {
    color: var(--icon-button-accent-color);
    font-size: 16px;
    transition: all 0.2s ease;
  }
`;
